import React, { useState } from 'react';
import { ReactComponent as ArrowDownIcon } from '../../assets/arrow-down.svg';

const StartPointPage = ({ userData, updateUserData, onNext, currentStep, totalSteps }) => {
    const [isAssetsOpen, setIsAssetsOpen] = useState(false);
    const [isIncomeOpen, setIsIncomeOpen] = useState(false);

    const assetsOptions = [
        "Дом",
        "Машина",
        "Бизнес",
        "Смартфон",
        "Ноутбук",
    ];

    const incomeOptions = [
        "До 30 000₽",
        "30 000₽ - 60000₽",
        "60 000₽ - 100 000₽",
        "100 000₽ - 200 000₽",
        "200 000₽ - 500 000₽",
        "500 000₽ - 1 000 000₽",
        "1 000 000₽ +"
    ];

    const adjustValue = (field, increment) => {
        const currentValue = userData.startPoint[field];
        let newValue;

        if (field === 'weight') {
            newValue = Math.max(40, Math.min(150, currentValue + increment));
        } else if (field === 'condition') {
            newValue = Math.max(1, Math.min(10, currentValue + increment));
        }

        updateUserData(`startPoint.${field}`, newValue);
    };

    const handleSkip = () => {
        onNext();
    };

    return (
        <div className="onboarding-page">
            <div className="onboarding-header">
                <h2>ТОЧКА А: СЕЙЧАС</h2>
                <p>Укажите ваше текущее состояние</p>
            </div>

            <div className="onboarding-content">
                <div className="form-group">
                    <label>
                        Вес
                        <span className="current-value">
                            {userData.startPoint.weight === 40 ? "менее 40" :
                                userData.startPoint.weight === 150 ? "более 150" :
                                    `${userData.startPoint.weight} кг`}
                        </span>
                    </label>
                    <div className="slider-container">
                        <button onClick={() => adjustValue('weight', -1)}>-</button>
                        <input
                            type="range"
                            min="40"
                            max="150"
                            value={userData.startPoint.weight}
                            onChange={(e) => updateUserData('startPoint.weight', parseInt(e.target.value))}
                        />
                        <button onClick={() => adjustValue('weight', 1)}>+</button>
                    </div>
                </div>

                <div className="form-group">
                    <label>Активы</label>
                    <div className="dropdown">
                        <div
                            className="dropdown-header"
                            onClick={() => setIsAssetsOpen(!isAssetsOpen)}
                        >
                            {userData.startPoint.assets || "Выберите диапазон"}
                            <ArrowDownIcon className={`arrow-icon ${isAssetsOpen ? 'up' : ''}`} />
                        </div>
                        {isAssetsOpen && (
                            <ul className="dropdown-list">
                                {assetsOptions.map((option) => (
                                    <li
                                        key={option}
                                        onClick={() => {
                                            updateUserData('startPoint.assets', option);
                                            setIsAssetsOpen(false);
                                        }}
                                    >
                                        {option}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className="form-group">
                    <label>Уровень дохода</label>
                    <div className="dropdown">
                        <div
                            className="dropdown-header"
                            onClick={() => setIsIncomeOpen(!isIncomeOpen)}
                        >
                            {userData.startPoint.income || "Выберите диапазон"}
                            <ArrowDownIcon className={`arrow-icon ${isIncomeOpen ? 'up' : ''}`} />
                        </div>
                        {isIncomeOpen && (
                            <ul className="dropdown-list">
                                {incomeOptions.map((option) => (
                                    <li
                                        key={option}
                                        onClick={() => {
                                            updateUserData('startPoint.income', option);
                                            setIsIncomeOpen(false);
                                        }}
                                    >
                                        {option}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className="form-group">
                    <label>
                        Состояние
                        <span className="current-value">
                            {userData.startPoint.condition === 1 ? "очень плохо" :
                                userData.startPoint.condition === 10 ? "отлично" :
                                    `${userData.startPoint.condition}/10`}
                        </span>
                    </label>
                    <div className="slider-container">
                        <button onClick={() => adjustValue('condition', -1)}>-</button>
                        <input
                            type="range"
                            min="1"
                            max="10"
                            value={userData.startPoint.condition}
                            onChange={(e) => updateUserData('startPoint.condition', parseInt(e.target.value))}
                        />
                        <button onClick={() => adjustValue('condition', 1)}>+</button>
                    </div>
                </div>
            </div>

            <div className="onboarding-footer">
                <div className="progress-dots">
                    {Array.from({ length: totalSteps }, (_, i) => (
                        <div
                            key={i}
                            className={`progress-dot ${i + 1 === currentStep ? 'active' : ''}`}
                        />
                    ))}
                </div>
                <button className="skip-button" onClick={handleSkip}>
                    Заполнить позже
                </button>
                <button
                    className="next-button"
                    onClick={onNext}
                >
                    Далее
                </button>
            </div>
        </div>
    );
};

export default StartPointPage; 